module.exports = __webpack_public_path__ + "img/sign-out-icon.975a7685.svg";